import type { FC, ReactNode } from 'react'
import type { StockStatus } from '@/types'

import { CircleCheck, CircleX, TriangleAlert } from 'lucide-react'
import { cn } from '@/lib/utils'
import { STOCK_STATUS_META } from '@/constants/inventory'

interface StockStatusBadgeProps {
    status: StockStatus
    className?: string
}

const STYLES: Record<StockStatus, string> = {
    ok: 'bg-success-soft text-success-ink',
    low: 'bg-warning-soft text-warning-ink',
    out: 'bg-danger-soft text-danger-ink'
}

const ICONS = {
    ok: CircleCheck,
    low: TriangleAlert,
    out: CircleX
}

const StockStatusBadge: FC<StockStatusBadgeProps> = ({ status, className }): ReactNode => {
    const Icon = ICONS[status]

    return (
        <span
            className={cn(
                'inline-flex h-6 shrink-0 items-center gap-1 rounded-full px-2 text-xs font-medium whitespace-nowrap',
                STYLES[status],
                className
            )}
        >
            <Icon className='size-3.5' aria-hidden='true' />
            {STOCK_STATUS_META[status].label}
        </span>
    )
}

export default StockStatusBadge
